import React, { ReactElement } from "react";

import { LoginMainTitle } from "@/components/atoms/typograhies/LoginMainTitle";
import { LayoutLoginTemplate } from "@/components/templates/layout/Login";

const styles = {
  wrapper: "p-2 bg-theme-thin rounded-2xl md:p-4",
  inner:
    "py-4 px-2 space-y-6 md:space-y-10 bg-white rounded-2xl md:py-6 md:px-[13.75%]",
  section: "space-y-2",
  header: "font-bold",
};

export default function CommerceLaw() {
  return (
    <article className="mx-auto max-w-[992px] md:pt-14">
      <LoginMainTitle
        title="特定商取引法に基づく表示"
        className="mb-11 text-center md:mb-6"
      />
      <div className={styles.wrapper}>
        <div className={styles.inner}>
          <section>
            <p>特定商取引法に基づく表示</p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>事業者の名称</h2>
            <p>オーガニックスタイル 株式会社</p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>所在地</h2>
            <p>〒167-0053&nbsp;&nbsp;東京都杉並区西荻南２−２４−７</p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>運営責任者</h2>
            <p>代表取締役&nbsp;&nbsp;渡邊&nbsp;&nbsp;隆</p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>連絡先</h2>
            <p>
              <a href="mailto:support@yoyacoo.jp">support@yoyacoo.jp</a>
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>営業時間</h2>
            <p>平日 10時〜18時 (土日祝祭日休)</p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>サービス名</h2>
            <p>予約プラットフォーム&nbsp;&nbsp;Yoyacoo（ヨヤクー）</p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>役務の対価</h2>
            <p>
              <a href="https://yoyacoo.jp/#priceSec">価格表</a>
              をご確認ください。税込価格となります。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>引き渡し時期</h2>
            <p>
              有料プラン利用料のお支払いが完了後直ちに引き渡します。なお、料金規約もご参照ください。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>販売価格以外に必要な費用</h2>
            <p>料金規約において定めます。</p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>返品・交換</h2>
            <p>
              サービスの性質上、返品・交換は承っておりません。
              <br />
              解約等の手続は、
              <a href="https://yoyacoo.jp/user/terms">利用規約</a>に定めます。
            </p>
          </section>
        </div>
      </div>
    </article>
  );
}

CommerceLaw.getLayout = function getLayout(page: ReactElement) {
  return <LayoutLoginTemplate isTextLeft={true}>{page}</LayoutLoginTemplate>;
};
